/* eslint-disable */
/**
 * AUTO-GENERATED by scripts/write-version.cjs at build time.
 * Do not edit by hand; regenerated on every `npm run start` /
 * `npm run build`.
 *
 * The admin "Service health" panel imports WEB_VERSION as the
 * comparison anchor for the backend's reported SHA: matches =
 * deploys are in sync; differs = a GitHub /compare link surfaces
 * the exact commit list pending on the backend.
 */
export const WEB_VERSION = {
  sha: "7e9a491bda3e4c32d7e1af7a786db72edd5fa61c",
  shortSha: "7e9a491",
  subject: "Merge pull request #11 from a7medkamel/feat/device-login-foundation",
  commitDate: "2026-07-19T16:22:12-07:00",
  branch: "main",
  dirty: true,
  builtAt: "2026-07-19T23:22:39.642Z",
} as const;
